import { useSelector } from 'react-redux';
import { getUserInfoUserType } from 'state/referenceData/referenceDataSelectors';

export const useUserType = () => useSelector(getUserInfoUserType);
